module.exports = __webpack_public_path__ + "static/Karim-dc832816f1da2f51cf616cb014edde6b.png";